export default __webpack_public_path__ + "static/media/hamburger.53b61e88.svg";